import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './Views/Landings/Home';
import Login from './Views/Login/Login';
import Dashboard from './Views/Dashboard/Dashboard';
import 'bootstrap/dist/js/bootstrap.bundle';
import ProtectedRoute from './Services/ProtectedRoute';
import Profile from './Views/Profile/Profile';
import Header from './Components/Header/Header';
import Navbar from './Components/Navbar/Navbar';
import UserBank from './Views/Profile/UserBank';
import Attendance from './Views/Attendance/Attendance';
import '@fullcalendar/bootstrap';
import '@fullcalendar/daygrid';
import AllCreditCard from './Views/Credit Card/AllCreditCard';
import ApplyCreditCard from './Views/Credit Card/ApplyCreditCard';
import ApplyLaterCreditCard from './Views/Credit Card/ApplyLaterCreditCard';
import AllCreditCardAdmin from './Views/Credit Card/AllCreditCardAdmin';
import CreateUser from './Views/User/CreateUser';
import CreateRole from './Views/User/CreateRole';
import About from './Views/Landings/About';
import Service from './Views/Landings/Service';
import Team from './Views/Landings/Team';
import Contact from './Views/Landings/Contact';
import Creditcardservice from './Views/Landings/services/creditcardservice';
import Creditcardswipeservice from './Views/Landings/services/creditcardswipeservice';
import Eshramservice from './Views/Landings/services/e-shramservice';
import Insuranceservice from './Views/Landings/services/insuranceservice';
import Loanservice from './Views/Landings/services/loanservice';
import Passportservicesservice from './Views/Landings/services/passportservicesservice';
import PanCardservices from './Views/Landings/services/panCardservices';
import Udhyamservice from './Views/Landings/services/udhyamservice';
import VoterIDcardservice from './Views/Landings/services/voterIDcardservice';
import Incometaxservicesservice from './Views/Landings/services/incometaxservicesservice';
import Allservicesdata from './Views/allservicesdata/allservicesdata';
import LoanApply from './Views/LoanApplication/loanApplication';
import AllLoans from './Views/LoanApplication/getAgentLoanData';
import AllLoansAdmin from './Views/LoanApplication/getAllLoanData';
import CreateService from './Views/Services/CreateService';
import AllServicesAdmin from './Views/Services/AllServicesAdmin';
import GroupPage from './Views/Services/GroupPage';
import ServiceGroupManager from './Views/Services/ServiceGroupManager';
import AssignServiceGroup from './Views/Services/AssignServiceGroup';
import ServiceApplyPage from './Views/Services/ServiceApplyPage';
import AllServiceApplicationAdmin from './Views/Services/GetAllServiceApplications';
import AllServiceApplication from './Views/Services/GetAllServiceApplicationsAgent';


function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Retrieve user data from localStorage when the component mounts
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setUser(storedUser); // If user is found in localStorage, set it to the state
    }
  }, []);

  return (
    
    <Router>
      <MainLayout user={user} setUser={setUser} />
    </Router>
  );
}

// Component to manage conditional rendering of Navbar and Header
function MainLayout({ user, setUser }) {
  const location = useLocation();

  // Define routes where Navbar and Header should NOT appear
  const excludedRoutes = ['/login', 
    '/', 
    '/about', 
    '/service',
    '/team',
    '/contact',
    '/creditcardservice',
    '/creditcardswipeservice',
    '/e-shramservice',
    '/insuranceservice',
    '/loanservice',
    '/passportservicesservice',
    '/pancardServices',
    '/udhyamservice',
    '/voterIDcardservice',
    '/incometaxservicesservice',
  
  ]; // Add other paths as needed

  const shouldShowLayout = !excludedRoutes.includes(location.pathname);

  return (
    <>
  {/* <SupportFloatingIcon/> */}

      {shouldShowLayout && <Navbar />}
      {shouldShowLayout && user && <Header />} {/* Header for logged-in users */}
      <Routes>
        <Route path="/" element={<Home setUser={setUser} />} />
        <Route path="/group/:groupId" element={<GroupPage setUser={setUser}/>} />
        <Route path="/assignservicegroup" element={<AssignServiceGroup setUser={setUser}/>} />
        <Route path="/service/:serviceId/apply" element={<ServiceApplyPage setUser={setUser}/>} />
        <Route path="/service-group-manager" element={<ServiceGroupManager setUser={setUser}/>} />
        <Route path="/about" element={<About setUser={setUser} />} />
        <Route path="/service" element={<Service setUser={setUser} />} />
        <Route path="/team" element={<Team setUser={setUser} />} />
        <Route path="/contact" element={<Contact setUser={setUser} />} />
        <Route path="/creditcardservice" element={<Creditcardservice setUser={setUser} />} />
        <Route path="/creditcardswipeservice" element={<Creditcardswipeservice setUser={setUser} />} />
        <Route path="/e-shramservice" element={<Eshramservice setUser={setUser} />} />
        <Route path="/insuranceservice" element={<Insuranceservice setUser={setUser} />} />
        <Route path="/loanservice" element={<Loanservice setUser={setUser} />} />
        <Route path="/passportservicesservice" element={<Passportservicesservice setUser={setUser} />} />
        <Route path="/pancardServices" element={<PanCardservices setUser={setUser} />} />
        <Route path="/udhyamservice" element={<Udhyamservice setUser={setUser} />} />
        <Route path="/voterIDcardservice" element={<VoterIDcardservice setUser={setUser} />} />
        <Route path="/incometaxservicesservice" element={<Incometaxservicesservice setUser={setUser} />} />
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route path="/profile" element={<Profile setUser={setUser} />} />
        <Route path="/userbank" element={<UserBank setUser={setUser} />} />
        <Route path="/attendance" element={<Attendance setUser={setUser} />} />
        <Route path="/allcreditcarddata" element={<AllCreditCard setUser={setUser} />} />
        <Route path="/loanApplications" element={<LoanApply setUser={setUser} />} />
        <Route path="/getAgentLoans" element={<AllLoans setUser={setUser} />} />
        <Route path="/applycreditcard" element={<ApplyCreditCard setUser={setUser} />} />
        <Route path="/applylatercreditcard" element={<ApplyLaterCreditCard setUser={setUser} />} />
        <Route path="/allserviceapplication" element={<AllServiceApplication setUser={setUser} />} />
        <Route path="/allcreditcard" element={<ProtectedRoute allowedRoles={['Admin']}><AllCreditCardAdmin setUser={setUser} /></ProtectedRoute>} />
        <Route path="/alluser" element={<ProtectedRoute allowedRoles={['Admin']}><CreateUser setUser={setUser} /></ProtectedRoute>} />
        <Route path="/getallloan" element={<ProtectedRoute allowedRoles={['Admin']}><AllLoansAdmin setUser={setUser} /></ProtectedRoute>} />
        <Route path="/roles" element={<ProtectedRoute allowedRoles={['Admin']}><CreateRole setUser={setUser} /></ProtectedRoute>} />
        <Route path="/allservicesdata" element={<ProtectedRoute allowedRoles={['Admin']}><Allservicesdata setUser={setUser} /></ProtectedRoute>} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={['Admin']}>
              <Dashboard setUser={setUser} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/allserviceapplicationadmin"
          element={
            <ProtectedRoute allowedRoles={['Admin']}>
              <AllServiceApplicationAdmin setUser={setUser} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/CreateServices"
          element={
            <ProtectedRoute allowedRoles={['Admin']}>
              <CreateService setUser={setUser} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/services/edit/:id"
          element={
            <ProtectedRoute allowedRoles={['Admin']}>
              <CreateService setUser={setUser} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/allservices"
          element={
            <ProtectedRoute allowedRoles={['Admin']}>
              <AllServicesAdmin setUser={setUser} />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
